import React from 'react';

export const AuthPageContext = React.createContext<{
  setFooterAction: (action: React.ReactNode) => void;
  setSocialLogin: (content: React.ReactNode) => void;
  setLogo: (content: React.ReactNode) => void;
  setHeaderTitle: (content: React.ReactNode) => void;
} | null>(null);
